var $ = require("jquery");
import { gsap, ScrollTrigger } from "./globals.js";
import { isLargeNonTouchDevice } from './globals.js';

// BTN ARROWS
if (isLargeNonTouchDevice()) {
  $(document).ready(function () {
  	$(".ui-btn, .menu-item--btn > a").each(function () {
  	  var text = $(this).text();
  	  $(this).html('<span>' + text + '</span><span class="ui-btn__arrow"><span></span></span>');
  	});

  	initMagneticArrows();
  });

  // MAGNETIC
  function initMagneticArrows() {
      const magneticElements = document.querySelectorAll(".ui-btn__arrow span");
      const strength = 15;

      if (magneticElements.length > 0) {
        magneticElements.forEach((el) => {
          const parent = el.parentElement;
          if (!parent) return;

          parent.addEventListener("mousemove", (e) => {
            const rect = parent.getBoundingClientRect();
            const relX = e.clientX - rect.left - rect.width / 2;
            const relY = e.clientY - rect.top - rect.height / 2;

            gsap.to(el, {
              x: (relX / rect.width) * strength,
              y: (relY / rect.height) * strength,
              duration: 0.2,
              ease: "power2.out",
            });
          });

          parent.addEventListener("mouseleave", () => {
            gsap.to(el, {
              x: 0,
              y: 0,
              duration: 0.2,
              ease: "power3.out",
            });
          });
        });
      }
  }
}
